<a mat-icon-button class="xsmall-button" (click)="deleteNode()" matTooltip="{{'general.remove' | transloco}}">
    <mat-icon>delete_outline</mat-icon>
</a>
